import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 21 is zoneless unless this is provided; data from the Parse SDK
    // (plain Promises) then never redraws the view until a user gesture.
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideAnimations()
  ]
};
